import { mergeModules } from "../core"
import reducer from "./reducer"
import list from "./list"
import reviews from "./reviews"

export * from "./selectors"

export default mergeModules({ reducer }, list, reviews)
